import React, { useEffect } from "react";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import Home from "./home";
import { ScrollingProvider } from "react-scroll-section";
import Top from "./components/top";

export default function App() {
  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://cdn-cookieyes.com/client_data/1ee8b827716611ae2a7c2e48/script.js";

    script.id = "cookieyes";
    document.head.prepend(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const routes: RouteObject[] = [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "polityka-prywatnosci/",
      element: <Navigate to="/" replace />,
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ];
  const element = useRoutes(routes);

  return (
    <div className="App">
      <ScrollingProvider>
        <Top />
        {element}
      </ScrollingProvider>
    </div>
  );
}
